import { useState } from "react";
import { saveHSNDetails } from "../Api/HSN";
import { Container, Form, Button, Row, Col } from "react-bootstrap";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Sample14 from "../Components/Logo";
//import "../Styling/HSN.css";

const HSNMaster = () => {
  const [hsnData, setHsnData] = useState({
    code: "",
    name: "",
    taxType: "",
    taxPercentage: "",
  });

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const userId = userDetails?.userId;

  const handleChange = (e) => {
    setHsnData({ ...hsnData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await saveHSNDetails(hsnData, userId);
      toast.success(`🦄 HSN Added Successfully`);
      setHsnData({
        code: "",
        name: "",
        taxType: "",
        taxPercentage: "",
      });
      navigate("/viewHSNData");
    } catch (error) {
      toast.error(`🦄 Error saving HSN: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
      <div className="main-content expand">
        <Container fluid className="fields-container">
          <h2 className="fields-title">HSN Master</h2>

          {loading && (
            <div className="loading-overlay">
              <Sample14 />
            </div>
          )}

          <Form onSubmit={handleSubmit} className="fields-form">
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>HSN Code <span className="text-red">**</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="code"
                    value={hsnData.code}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Name <span className="text-red">**</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="name"
                    value={hsnData.name}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Tax Type <span className="text-red">**</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="taxType"
                    value={hsnData.taxType}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Tax Percentage <span className="text-red">**</span></Form.Label>
                  <Form.Control
                    type="number"
                    name="taxPercentage"
                    value={hsnData.taxPercentage}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>

            <div className="fields-btn-container">
              <Button
                variant="primary"
                type="submit"
                className="fields-submit"
                disabled={loading}
              >
                {loading ? "Saving..." : "Save HSN"}
              </Button>
            </div>
          </Form>
        </Container>
      </div>
  );
};

export default HSNMaster;